module.exports = __webpack_public_path__ + "img/priori_incantatem.62e18444.jpg";